import React from 'react';
import AboutTechXplore from './AboutTechXplore';
import MeetTheFounder from './MeetTheFounder';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import CallToAction from '../../LandingSection/CallToAction';
import BeliefsSection from './BeliefsSection';

const AboutPage = () => {
  return (
    <>
      <Header bgColor="#242424"/>
      <AboutTechXplore />
      {/* <MeetTheFounder /> */}
      <BeliefsSection/>
      <CallToAction/>
      <Footer></Footer>
    </>
  );
};

export default AboutPage;
